import React, { useState, useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const animateCounter = (element, target, duration = 2000) => {
    let start = 0;
    const increment = target / (duration / 16);

    const updateCounter = () => {
      start += increment;
      if (start < target) {
        element.textContent = Math.floor(start) + '+';
        requestAnimationFrame(updateCounter);
      } else {
        element.textContent = target + '+';
      }
    };

    updateCounter();
  };

  useEffect(() => {
    if (isVisible) {
      const statElements = document.querySelectorAll('.stat-number');
      statElements.forEach((element, index) => {
        const targets = [320, 10, 200];
        setTimeout(() => {
          animateCounter(element, targets[index]);
        }, index * 200);
      });
    }
  }, [isVisible]);

  const features = [
    'Certified HR Professionals',
    'Industry Best Practices',
    'Customized Solutions',
    'Proven Track Record'
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-header">
          <h2>About HRCONSOL</h2>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p className="about-description">
              HRCONSOL – Redefining HR Solutions is a next-generation recruitment and blue-collar staffing company, combining technology, expertise, and innovation to deliver end-to-end HR solutions. With over a decade of experience, we have proudly served 320+ companies globally and built trusted relationships with 200+ satisfied clients across diverse industries.
            </p>
            <p className="about-description">
              As a SECP-registered entity and recognized by KCCI, EFP, Software Export Board, and GCC, HRCONSOL is positioned as an international recruitment supplier providing workforce solutions from executive search to blue-collar staffing, with a focus on sustainability, digitalization, and community impact.
            </p>
            <div ref={statsRef} className="stats">
              <div className="stat">
                <h3 className="stat-number">0+</h3>
                <p>Companies Served</p>
              </div>
              <div className="stat">
                <h3 className="stat-number">0+</h3>
                <p>Years of Experience</p>
              </div>
              <div className="stat">
                <h3 className="stat-number">0+</h3>
                <p>Satisfied Clients</p>
              </div>
            </div>
            
            <div className="global-presence">
              <h3>Global Presence – Pakistan & MENA Region</h3>
              <p>
                HRCONSOL is not just a local HR partner—we are a global solutions provider. With strong operations in Pakistan and expanding services across the MENA region (Middle East & North Africa), we deliver tailored recruitment and HR outsourcing solutions that cater to international standards.
              </p>
            </div>
          </div>
          <div className="about-mission-vision">
            <div className="mission-vision-item">
              <h3>Our Mission</h3>
              <p>To create sustainable HR solutions that empower businesses and communities while generating 10 million jobs globally.</p>
            </div>
            
            <div className="mission-vision-item">
              <h3>Our Vision</h3>
              <p>To be the leading HR Tech & Staffing partner worldwide, known for innovation, sustainability, and human capital excellence.</p>
            </div>
            
            <div className="mission-vision-item">
              <h3>Our Core Values</h3>
              <ul className="core-values-list">
                <li><strong>Integrity</strong> – Building trust through transparency and fairness.</li>
                <li><strong>Innovation</strong> – Leveraging technology to redefine HR practices.</li>
                <li><strong>Sustainability</strong> – Committed to Green HR and social impact initiatives.</li>
                <li><strong>Excellence</strong> – Delivering world-class HR solutions to clients and communities.</li>
                <li><strong>Empowerment</strong> – Uplifting blue-collar workers and women through education & opportunity.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
